export default {"src":"/_next/static/media/wxdai.3ec8b5e7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};